import { updateSubjectApi } from "@/api/services/admin/learning-content";
import { TUpdateSubjectReqDto } from "@/api/services/admin/learning-content/dtos/update-subject.dto";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type TUpdateMemoParams = {
  name: string;
  memo: string;
};

/**
 * Hook to update only the internalMemo field of a subject.
 * Designed for blur-to-save on the detail page's 社内メモ field.
 * Requires `name` because the update API mandates it.
 */
export const useUpdateSubjectMemo = (subjectId?: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ name, memo }: TUpdateMemoParams) => {
      if (!subjectId) return Promise.reject(new Error("Missing subjectId"));
      const payload: TUpdateSubjectReqDto = { name, internalMemo: memo || null };
      return updateSubjectApi(subjectId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_SUBJECT_DETAIL, subjectId] });
      toast.success(API_SUCCESS_MESSAGE);
    },
    onError: (error) => {
      showError(error);
    },
  });

  return mutation;
};
